import { createContext } from 'react'
import type { IAnalytics } from 'shared/analytics/interface'

export const AnalyticsContext = createContext<IAnalytics | null>(null)
